// ABOUTME: Collection-card behavior the Horizon card component does not own: keeps the gallery from paging
// on hover under the jf-card-quick-shop crossfade, and points the hover image at a picked flavor's hover shot (D56).
// Scoped to cards that carry the hover layer; every other card surface keeps the stock hover preview.
import { StandardEvents } from '@shopify/events';

const HOVER_GALLERY = 'product-card:has(.jf-card-hover) .card-gallery[on\\:pointerenter]';

/**
 * The card gallery pages to its next slide on pointerenter (theme setting
 * show_second_image_on_hover); on hover-layer tiles the crossfade must land on the resting
 * packshot, so the gallery's own hover handlers come off. The handler attributes are read at
 * event time, so removing them is the whole opt-out.
 */
function stripGalleryHoverPaging() {
  for (const gallery of document.querySelectorAll(HOVER_GALLERY)) {
    gallery.removeAttribute('on:pointerenter');
    gallery.removeAttribute('on:pointerleave');
  }
}

let stripScheduled = false;

function scheduleStrip() {
  if (stripScheduled) return;
  stripScheduled = true;
  requestAnimationFrame(() => {
    stripScheduled = false;
    stripGalleryHoverPaging();
  });
}

stripGalleryHoverPaging();

// Infinite scroll appends cards, and filter/sort morphs can restore the attributes on
// existing galleries; both surface as mutations.
new MutationObserver(scheduleStrip).observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['on:pointerenter'],
});

/**
 * A swatch pick on a card fires the product-select event with the picked variant's id. When the card's hover
 * layer lists hover shots per variant (data-jf-variant-hovers, D56), the hover image switches to the picked
 * variant's shot, and back to the resting image for a variant without one.
 * @param {Event} event
 */
function followPickedVariant(event) {
  const card = event.target instanceof Element ? event.target.closest('product-card') : null;
  const layer = card?.querySelector('.jf-card-hover[data-jf-variant-hovers]');
  const image = layer?.querySelector('.jf-card-hover__image');
  const variantId = /** @type {{ variantId?: unknown }} */ (/** @type {CustomEvent} */ (event).detail ?? {}).variantId;
  if (!(layer instanceof HTMLElement) || !(image instanceof HTMLImageElement) || typeof variantId !== 'string') return;

  let hovers;
  try {
    hovers = JSON.parse(layer.dataset.jfVariantHovers ?? '{}');
  } catch {
    return;
  }
  if (image.dataset.restSrc === undefined) {
    image.dataset.restSrc = image.getAttribute('src') ?? '';
    image.dataset.restSrcset = image.getAttribute('srcset') ?? '';
  }
  const shot = hovers[variantId];
  image.setAttribute('srcset', shot ? shot.srcset : image.dataset.restSrcset ?? '');
  image.setAttribute('src', shot ? shot.src : image.dataset.restSrc);
}

document.addEventListener(StandardEvents.productSelect, followPickedVariant);
